import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type UserSourcesAssignments = {
   assignments: UserSourcesAssignment[];
};

export type UserSourcesAssignment = {
   created_date: number;
   assigner_name: string;
   teamid: number | null;
   assigner_userid: number;
   course_assignmentid: number;
   team_name: string | boolean | null;
};

export type GetUserSourcesAssignmentsOptions = CommonRequestOptions & {
   userid: number;
   wikiid?: number;
};

export async function getUserSourcesAssignments({
   userid,
   wikiid,
   ...common
}: GetUserSourcesAssignmentsOptions): Promise<UserSourcesAssignments> {
   return makeRequest('get', `/course_assignments/sources/user/${userid}`, {
      ...common,
      query: {
         wikiid,
      },
   });
}
